import React from "react";

// reactstrap components
import { Badge, Button, Card, Media, Container, Row, Col } from "reactstrap";
import './feat.css';

// core components
import DangerNavbar from "components/Navbars/DangerNavbar.js";
import BlogPostHeader4 from "components/Headers/BlogPostHeader4.js";
import FooterGray from "components/Footers/FooterGray.js";
import Buttons from "components/Headers/Buttons.js"
import Lottie from 'react-lottie';
import animationData from 'assets/lotties/beach.json';
import { useTranslation } from 'react-i18next';

const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};
function BlogPost4() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  const { t, i18n } = useTranslation();
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("blog-post4");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("blog-post4");
    };
  });
  return (
    <>

      <DangerNavbar />
      <br/>
   
   <Buttons/>
   <div    style={{height:"3px", backgroundColor: "gold"}} />

      <BlogPostHeader4 />
      <hr/>

      <div className="features-1"
         style={{
          backgroundColor:
          "#247AFD",
          color:"black",
          }}  
            >

     
          <Row>

          <Col className="ml-auto mr-auto" md="7">
          <h4>Tour Information</h4>
          <br/>
          <hr/>
                    <p>
{t('description.part25')}
                    </p>
                    </Col>
                    <Col className="ml-auto mr-auto" md="4">
<center>
<Lottie 
options={defaultOptions}
height='350px'
width='250px'
/></center>
</Col>
                    </Row>
          </div><hr/>
            
      

      <FooterGray />
    </>
  );
}

export default BlogPost4;
